import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './oem_user_edit.routes';
import OemUserService from '../../../../components/api/oem_user/oem_user.service';

export class OemUserEditController {
  /*@ngInject*/
  constructor($auth, $stateParams, $mdDialog, $state, OemUserService) {
    this.OemUserService = OemUserService;
    this.$mdDialog = $mdDialog;
    this.$state = $state;
    this.userData = {id: $stateParams.id};
    this.isSelf = true;
    this.$auth = $auth;

    this.editDialog = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '変更しますか？',
        ok: '変更する',
        cancel: '戻る'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: '変更しました',
        ok: 'OK'
      })
    };
    this.deleteDialog = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '削除してよろしいですか？',
        ok: '削除する',
        cancel: '戻る'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: '削除しました',
        ok: 'OK'
      })
    };
    this.errorAlert = $mdDialog.alert()
      .title('エラーが発生しました')
      .content('時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。')
      .ok('OK');
  }

  $onInit() {
    this.OemUserService.oem_api.show({id: this.userData.id},
      res => {
        this.userData = res;
        this.isSelf = (res.email === this.$auth.user.email);
      },
      err => {
        if (err.status === 404 || err.status === 403) {
          this.$state.go('oem_main.oem_home');
        }
      }
    )
  }

  updateUser(ev) {
    this.$mdDialog.show(this.editDialog.confirm.targetEvent(ev))
      .then(() => {
        this.OemUserService.oem_api.update(
          this.userData,
          () => {
            this.$mdDialog.show(this.editDialog.success)
              .finally(() => {
                this.$state.go('oem_main.oem_user_index');
              });
          },
          () => {
            this.$mdDialog.show(this.errorAlert);
          }
        );
      });
  }

  deleteUser(ev) {
    this.$mdDialog.show(this.deleteDialog.confirm.targetEvent(ev)).then(() => {
      this.OemUserService.oem_api.delete(
        {id: this.userData.id},
        () => {
          this.$mdDialog.show(this.deleteDialog.success).finally(() => {
            this.$state.go('oem_main.oem_user_index')
          });
        },
        () => {
          this.$mdDialog.show(this.errorAlert);
        }
      );
    });
  }
}

export default angular.module('leptonApp.oemUserEdit', [uiRouter, OemUserService])
  .config(routing)
  .component('oemUserEdit', {
    template: require('./oem_user_edit.html'),
    controller: OemUserEditController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/oem/oem_user/edit/oem_user_edit.component.js